export default function PoliticaDePrivacidad() {
  return null;
}